module.exports = __webpack_public_path__ + "img/continue-education.bf16169f.png";